import { useHistory } from 'react-router-dom'

import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import { GoBackIcon } from '../../../utils/iconRefs/recipeRatingIcons'
import styles from './RecipeFeedBackEditTitle.module.css'

const RecipeFeedBackEditTitle = ({ name }: { name: string }) => {
  const history = useHistory()
  
  const onBack = () => {
    history.push('/cooking-history')
  }

  return (
    <Grid className={styles.title_container}>
      <GoBackIcon onClick={onBack} />
      <Typography color="#fff" variant="h6">
        {name}
      </Typography>
    </Grid>
  )
}

export default RecipeFeedBackEditTitle